import { render, staticRenderFns } from "./DeliveredVehicle.vue?vue&type=template&id=41fedbe0"
import script from "./DeliveredVehicle.vue?vue&type=script&lang=ts"
export * from "./DeliveredVehicle.vue?vue&type=script&lang=ts"
import style0 from "./DeliveredVehicle.vue?vue&type=style&index=0&id=41fedbe0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports